module.exports = __webpack_public_path__ + "public/images/feedback.9883ce71af49c3f51f5f89791963ee3c.png";